/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-useless-constructor */
import BaseObserver from './baseObserver';
import get from 'lodash/get';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { getUrlParam } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import type { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import type EditingStateManager from '@src/slide/application/service/editing-state-manager';

export default class PictureModelObserver extends BaseObserver {
    declare public model: IPictureModel;
    private mediaManager: IMediaManager;
    private editingStateManager: EditingStateManager;

    public constructor(model, options) {
        super(model, options);
        this.mediaManager = options.mediaManager;
        this.editingStateManager = options.editingStateManager;
    }

    getObserveData(): Record<string, any> {
        const { operationFrame, operatingGraphicInfo, previewChange } = this.model;
        return {
            operationFrame,
            previewChange,
            operatingGraphicInfo,
            selected: this.model.selected,
            // 对选中的图片监听裁剪状态
            isCroping: this.model.selected && this.editingStateManager?.isCroping,
            isEditMode: browser.isMobile && this.mediaManager?.isEditMode && get(this.model, 'props.src') && (getUrlParam(this.model.props.src, '_type') === 'gif'), // 需要监听移动端，GIF 编辑状态的变化（预览态展示 GIF 动图，编辑态预览列表展示静态图）
        };
    }
}
